
export default {
    name: 'consultation-commentaire',
    components: {},
    props: ["consultation", "is_printable"],
    data() {
        return {
            is_loading: true,
            is_empty: false,
        }
    },

    computed: {
        consultation_commentaires_historique() {
            return this.$store.getters["consultation_commentaires_historique"]
        }
    },

    mounted() {
        this.refreshCommentaire()
    },

    methods: {
        refreshCommentaire() {
            
            this.is_loading = true 

            const data = {
                consultation_id: this.consultation.id,
                data_type: 'commentaire',
                est_encours: false
            }
            this.$store.dispatch('getConsultationInfoComplementaire', data).then(() => {
                console.log("refresh", this.consultation_commentaires_historique);
                if (this.consultation_commentaires_historique.length > 0) {
                    this.is_empty = false
                } else {
                    this.is_empty = true
                }
                this.is_loading = false
            })
        },
    }
}


